import React, { useState } from 'react';
import moment from 'moment';
import axios from 'axios';
import {
  Container,
  Modal,
  Form,
  Card,
  Row,
  Col,
  Button,
} from 'react-bootstrap';
import { getPutPostConfig } from '../../common/ResourceApi';
import { route } from '../../common/Util';
import PeopleLayout from '../layout/PeopleLayout';
import { LoadingAnimation, Icon } from '../../common/components/Utilities';

function RemoteWorkingForm(props) {
  return <PeopleLayout {...props} content={<RemoteWorkingBody {...props} />} />;
}

function FormYesNo({
  handleChangeFormData, formData, label, name,
}) {
  return (
    <Row className="border border-top-0 border-left-0 border-right-0 mb-3 pb-1">
      <Col md={1}>
        <Form.Group className="m-0" controlId={`${name}_yes`}>
          <Form.Check checked={formData[name] > 0} type="radio" label="Yes" value="1" name={name} onChange={handleChangeFormData} required />
        </Form.Group>
        <Form.Group controlId={`${name}_no`}>
          <Form.Check checked={name in formData && formData[name] < 1} type="radio" label="No" value="0" name={name} onChange={handleChangeFormData} required />
        </Form.Group>
      </Col>
      <Col md={11}>
        <Form.Label>{label}</Form.Label>
      </Col>
    </Row>
  );
}

function FormCheckbox({
  handleChangeFormData, formData, label, name,
}) {
  return (
    <Form.Group controlId={name}>
      <Row className="border border-top-0 border-left-0 border-right-0 mb-3 pb-1">
        <Col md={1}>
          <Form.Check defaultChecked={formData[name]} value="1" name={name} onChange={handleChangeFormData} required />
        </Col>
        <Col md={11}>
          <Form.Label>{label}</Form.Label>
        </Col>
      </Row>
    </Form.Group>
  );
}

function MessageModal({ modalData, setModalData, loading }) {
  if (!('message' in modalData)) {
    return null;
  }

  const handleClose = () => {
    setModalData({});
    if (modalData.type === 'success') {
      window.location = route.people();
    }
  };

  return (
    <Modal show={'message' in modalData} onHide={handleClose} size="lg">
      <LoadingAnimation loading={loading} />
      <Modal.Header closeButton>
        <Modal.Title>
          {modalData.type.charAt(0).toUpperCase() + modalData.type.slice(1)}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>

        {modalData.message}

      </Modal.Body>
      <Modal.Footer>
        <Button className="" type="button" variant="primary" onClick={handleClose}>{modalData.type === 'success' ? 'Go Home' : 'Close'}</Button>
      </Modal.Footer>
    </Modal>
  );
}

function RemoteWorkingBody({ activeUser }) {
  const [loading, setLoading] = useState(false);
  const [modalData, setModalData] = useState({});
  const [yesRemoteWorkingVisible, setYesRemoteWorkingVisible] = useState(false);
  const [noCommitHoursVisible, setNoCommitHoursVisible] = useState(false);
  const [formData, setFormData] = useState({
    full_name: activeUser.name,
    todays_date: moment().format('YYYY-MM-DD'),
    confirmation_raise_concerns: '',
    remote_working_distractions_yes_info: '',
    remote_working_commit_to_hours_no_info: '',
  });

  const handleChangeFormData = (event) => {
    const { name } = event.target;
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    if (name === 'remote_working_distractions') {
      setYesRemoteWorkingVisible(!!Number(value));
    }
    if (name === 'remote_working_commit_to_hours') {
      setNoCommitHoursVisible(!Number(value));
    }
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    await axios.post('/resource/remote-working', { form_data: formData }, getPutPostConfig())
      .then(() => {
        setModalData({ type: 'success', message: 'We have successfully received your Remote Working Induction form.' });
      }).catch((error) => {
        setModalData({ type: 'error', message: error.response.data });
      }).then(() => {
        setLoading(false);
      });
  };

  return (
    <Container>
      <MessageModal modalData={modalData} setModalData={setModalData} loading={loading} />
      <Form onSubmit={handleSubmit}>
        <LoadingAnimation loading={loading} />
        <Row className="justify-content-md-center mb-4">
          <Col md={8}>
            <Card>
              <Card.Body>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3" controlId="full_name">
                      <Form.Label>Full Name</Form.Label>
                      <Form.Control type="text" name="full_name" placeholder="" value={formData.full_name} onChange={handleChangeFormData} required />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="form-group-today-date">
                      <Form.Label>Todays Date</Form.Label>
                      <Form.Control type="date" name="todays_date" value={formData.todays_date} onChange={handleChangeFormData} required />
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* {activeUser.location.name.indexOf('UK') !== -1 && ( */}

        <Row className="justify-content-md-center mb-4">
          <Col md={8}>
            <Card>
              <Card.Body>
                <h2 className="mb-4">Workstation Assessment</h2>
                <FormYesNo handleChangeFormData={handleChangeFormData} formData={formData} label="Check you are able to sit in the correct position on your chair, hips slightly higher than your knees, feet on the floor, elbows at 90 degrees and head and neck straight. Ensure you lean on the back of the chair and your lower back is supported." name="workstation_sit_correctly" />
                <FormYesNo handleChangeFormData={handleChangeFormData} formData={formData} label="If you intend to work from the kitchen table, remember, they are usually higher than desks, so this should be considered when positioning yourself at the homework station. Check this is suitable." name="workstation_kitchen_table" />
                <FormYesNo handleChangeFormData={handleChangeFormData} formData={formData} label="Raise your laptop/monitor so that the top part of the screen is in line with your eyes and to avoid bending your neck." name="workstation_raise_monitor" />
                <FormYesNo handleChangeFormData={handleChangeFormData} formData={formData} label="If you have needed to raise your laptop, use a separate keyboard and mouse and avoid using the touchpad and keyboard on your laptop." name="workstation_seperate_key_mouse" />
                <FormYesNo handleChangeFormData={handleChangeFormData} formData={formData} label="All the items which are to be used constantly (keyboard, mouse, mobile phone), should be easily reachable without stretching your arms. This will allow you to work without stressing your body." name="workstation_stretching" />
                <FormYesNo handleChangeFormData={handleChangeFormData} formData={formData} label="Your workstation should look like your standard office desk setup. Check this." name="workstation_standard" />
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* )} */}

        <Row className="justify-content-md-center mb-4">
          <Col md={8}>
            <Card>
              <Card.Body>
                <h2 className="mb-4">Confirmation</h2>
                <p>
                  <a href="https://docs.google.com/document/d/1CqCB3yUmbvYt1Z-Si2veGmzKFEPGBDVbWYB8GdDMBRs/edit#heading=h.cxf8oyoeq15a" target="_blank" rel="noreferrer">
                    <Icon icon="link" append="mr-1" />
                    Remote Working Guidance & Best Practice Document
                  </a>
                </p>
                <FormCheckbox handleChangeFormData={handleChangeFormData} formData={formData} label="I have read and understood the 'Health & Safety' section of the Remote Working Guidance & Best Practice" name="confirmation_read_and_understood" />
                <FormCheckbox handleChangeFormData={handleChangeFormData} formData={formData} label="I have completed a self assessment of my workstation at home" name="confirmation_self_assessment" />
                <FormCheckbox handleChangeFormData={handleChangeFormData} formData={formData} label="My home working conditions are satisfactory" name="confirmation_conditions_satisfactory" />

                <Form.Group className="mb-3" controlId="confirmation_raise_concerns">
                  <Form.Label>Do you have any concerns you would like to raise?</Form.Label>
                  <Form.Control type="text" name="confirmation_raise_concerns" placeholder="" value={formData.confirmation_raise_concerns} onChange={handleChangeFormData} required />
                </Form.Group>

              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="justify-content-md-center mb-4">
          <Col md={8}>
            <Card>
              <Card.Body>
                <h2 className="mb-4">Remote Working</h2>
                <p>
                  In order to work from home please
                  confirm that you have the following in place:
                </p>

                <FormYesNo handleChangeFormData={handleChangeFormData} formData={formData} label="A safe and reasonable place to work" name="remote_working_safe_place" />
                <FormYesNo handleChangeFormData={handleChangeFormData} formData={formData} label="A secure internet connection" name="remote_working_secure_internet" />
                <FormYesNo handleChangeFormData={handleChangeFormData} formData={formData} label="A company laptop" name="remote_working_laptop" />

                <FormYesNo handleChangeFormData={handleChangeFormData} formData={formData} label="Do you have any distractions at home that may impact on your ability to perform your job?" name="remote_working_distractions" />

                {yesRemoteWorkingVisible && (

                  <Form.Group className="mb-3" controlId="remote_working_distractions_yes_info">
                    <Form.Label>If yes, please provide detail</Form.Label>
                    <Form.Control type="text" name="remote_working_distractions_yes_info" placeholder="" value={formData.remote_working_distractions_yes_info} onChange={handleChangeFormData} required />
                  </Form.Group>

                )}

                <FormYesNo handleChangeFormData={handleChangeFormData} formData={formData} label="Are you able to commit to your full and standard contractual working hours from home?" name="remote_working_commit_to_hours" />

                {noCommitHoursVisible && (

                <Form.Group className="mb-3" controlId="remote_working_commit_to_hours_no_info">
                  <Form.Label>If no, please provide detail</Form.Label>
                  <Form.Control type="text" name="remote_working_commit_to_hours_no_info" placeholder="" value={formData.remote_working_commit_to_hours_no_info} onChange={handleChangeFormData} required />
                </Form.Group>

                )}

              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="justify-content-md-center mb-4">
          <Col md={8}>
            <Card>
              <Card.Body>

                <h2 className="mb-4">Employee Declaration</h2>
                <p>I declare that I have read and fully understand the following documents...</p>
                <p>These documents can be found on our Intranet:</p>
                <p>
                  <a href="https://sites.google.com/gear4music.com/g4mmanchester/home/useful-links" target="_blank" rel="noreferrer">
                    <Icon icon="link" append="mr-1" />
                    https://sites.google.com/gear4music.com/g4mmanchester/home/useful-links
                  </a>
                </p>
                <FormCheckbox handleChangeFormData={handleChangeFormData} formData={formData} label="Homeworking Policy" name="employee_declaration_homeworking" />
                <FormCheckbox handleChangeFormData={handleChangeFormData} formData={formData} label="Remote Working Guidance & Best Practice" name="employee_declaration_remote" />
                <FormCheckbox handleChangeFormData={handleChangeFormData} formData={formData} label="Employee Handbook" name="employee_declaration_handbook" />

                <p>
                  I understand my responsibilities around usage of company
                  hardware and confirm that I...
                </p>
                <FormCheckbox handleChangeFormData={handleChangeFormData} formData={formData} label="Will not use the company laptop for personal use" name="employee_declaration_laptop_personal_use" />
                <FormCheckbox handleChangeFormData={handleChangeFormData} formData={formData} label="Will ensure my laptop is secured when not in use" name="employee_declaration_laptop_security" />

                <p>I confirm that I...</p>
                <FormCheckbox handleChangeFormData={handleChangeFormData} formData={formData} label="Am able to commit to my contractual working hours as per my Contract of Employment" name="employee_declaration_commit_to_hours" />
                <FormCheckbox handleChangeFormData={handleChangeFormData} formData={formData} label="Will inform the Ops Team if I am unable to work my contracted hours" name="employee_declaration_unable_to_work" />
                <FormCheckbox handleChangeFormData={handleChangeFormData} formData={formData} label="Am aware that any breach of company policies or procedures may result in disciplinary action" name="employee_declaration_breach_policies" />

              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="text-center">

            <LoadingAnimation loading={loading} />
            {!loading && (
              <Button type="submit" className="btn-lg">Submit</Button>
            )}

          </Col>
        </Row>
      </Form>
    </Container>
  );
}

export default RemoteWorkingForm;
